export const SWITCH_STYLES = {
  checkedIcon: false,
  uncheckedIcon: false,
  offColor: "#1E314F",
  onColor: "#1E314F",
  height: 20,
  width: 40,
  handleDiameter: 15,
};
